import * as React from "react";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import {
    MessagingReplyModal,
    MessagingReplyModalProps
} from "@teamprevent/common/messaging/components/MessagingReplyModal";
import { ThunkDispatch } from "redux-thunk";

interface MessagingReplyModalButtonProps {
    caseId: string;
    subject: string;
    buttonText: string;
    showReply: boolean;
    customerId: string;
    action?: () => void;
    employeeName: string;
    // This dispatch action is called when the modal is opened
    onModalOpenDispatchAction?: () => void;
}

const MessagingReplyModalButton: React.FC<MessagingReplyModalButtonProps> = ({
    caseId,
    subject,
    buttonText,
    showReply,
    customerId,
    action,
    employeeName,
    onModalOpenDispatchAction,
}) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const [openModal, setOpenModal] = React.useState<boolean>(false);
    const caseConversationImprovements = getFeatureToggles()[FeatureToggleNames.CaseConversationImprovements];

    const invokeAction = React.useCallback(() => {
        if (action) {
            dispatch(action());
        }
    }, [action, dispatch]);

    const onCloseModal = React.useCallback(() => {
        invokeAction();
        setOpenModal(false);
    }, [invokeAction],);

    const onModalOpen = React.useCallback(() => {
        if (onModalOpenDispatchAction && caseConversationImprovements) {
            dispatch(onModalOpenDispatchAction());
        }

        setOpenModal(true);
    }, [caseConversationImprovements, dispatch, onModalOpenDispatchAction]);

    const messagingReplyModalProps: MessagingReplyModalProps = {
        openModal,
        onCloseModal,
        subject,
        caseId,
        showReply,
        customerId,
        employeeName,
    };

    return (
        <>
            <Button onClick={onModalOpen}>{buttonText}</Button>
            <MessagingReplyModal {...messagingReplyModalProps} />
        </>
    );
};

export { MessagingReplyModalButton };
